import React from 'react';
import { Container, Row, Col, Input, FormGroup, Form, Button } from 'reactstrap';
import axios from 'axios';
import { subscribe } from 'react-contextual';
import getConfig from 'next/config';

const config = getConfig().publicRuntimeConfig;

class NewsletterPanel extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			messageSubmitted: false,
		};
	}

	submitNewsletterSubscriptionForm = (event) => {
		event.preventDefault();

		const name = document.getElementById('ns-sub-panel-name').value;
		const email = document.getElementById('ns-sub-panel-email').value;

		axios({
			method: 'post',
			url: `/api/v1.1/leadGen/create`,
			data: {
				email,
				name,
				source: 'newsletters',
				_csrf: this.props._csrf
			},
		}).then((res) => {
			if (res.data.status) {
				const eventData = {
					content_name: "newsletter-registration",
					status: true
				}

				if (window.eventDispatcher) {
					window.eventDispatcher.dispatchEvent('Lead', eventData, {fbPixel: true});
				}

				this.setState({
					messageSubmitted: true,
					message: 'Thank you for signing up!'
				});
			}
			else {
				this.setState({
					messageSubmitted: true,
					message: 'You have already signed up for our newsletter'
				});
			}
		}).catch((err) => {
		});

	}

	render() {
		return (
			<Container className="panel-padding" >
				<Row className="newsletter-box d-flex" style={{ height: "auto",  overflow: 'hidden' }} sm="12" xs="12" md="12" lg="12" >
					<Col xs="6" lg="2">
						<img
							className="newsletter-image-panel"
							style={{   width: '100%', marginRight: 'auto', overflow: 'hidden' }}
							src={`${config.cdnUrl}/static/images/Illustration-boy-leadgen-final.svg`}
							alt="Newsletter subscription image"
						/>
					</Col>
					<Col xs="6" lg="3" className=" d-flex justify-content-center align-self-center hide-mobile">
						<h5>Weekly dose of inspiration delivered straight to your inbox. Sign up here.</h5>
					</Col>

					<Col xs="12" lg="7" className="d-flex justify-content-center align-self-center newsletter-field-panel col-md-7">
						<Row className="w-100">
							{!this.state.messageSubmitted ?<Form className="form-inline w-100" onSubmit={e => this.submitNewsletterSubscriptionForm(e)}>
								<Col xs="12" lg="5" className="footer-panel-f4">
									<FormGroup>
										<Input style={{ width: '100%' }} required type="text" name="name" id="ns-sub-panel-name" placeholder="Your Name"  />
									</FormGroup>
								</Col>

								<Col xs="12" lg="5" className="footer-panel-f4">
									<FormGroup>
										<Input style={{ width: '100%' }} required type="email" name="Email" id="ns-sub-panel-email" placeholder="Enter your e-mail"  />
									</FormGroup>
								</Col>

								<Col xs="12" lg="2" className="footer-panel-f4 p-0">
									<FormGroup>
										<Button
											style={{
												width: '100%',
											}}
											color="secondary"
											className="btn-lg"
										> sign up
										</Button>
									</FormGroup>
								</Col>
							</Form>
								:
								<div className="justify-content-center" style={{alignItems: 'center',maxWidth: '100%', }}	>
									<p style={{ paddingTop: '1rem', fontSize: '20px'}}>{this.state.message}</p>
								</div>
							}
						</Row>

					</Col>

				</Row>
				<style global jsx>
					{
						`
						@media (max-width: 768px) {
							.footer-panel-f4{
								padding: 0px 0px 0px 0px !important;
							}
						}

						.newsletter-box {
							overflow: hidden;
							border-radius: 10px;
							box-shadow: 0 2px 4px 0 rgba(50,50,93,.1);
							border: 1px solid rgba(0,0,0,0.03);
						}

						.newsletter-box .form-inline .form-group {
							margin-bottom: 1rem;
						}

						.newsletter-field-panel{
							padding-top: 1rem;
						}

						`
					}
				</style>
			</Container>
		);
	}
}
export default subscribe()(NewsletterPanel);
